export default `
  listingStatistics(listingId:$id) {
    visited
    shared
    favorite
    interested
  }
`;
